const SCROLL_OFFSET = 80

export function scrollToAnchor(anchorId: string, offset: number = SCROLL_OFFSET): void {
  requestAnimationFrame(() => {
    const element = document.getElementById(anchorId)
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
      const offsetPosition = elementPosition - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      })
    }
  })
}
